export const ifitBlack = '#151515';
export const ifitBlue = '#0096d6';
export const blueSlate = '#022c39';
export const scienceBlue = '#0069d2';
export const cerulean = '#00c3e5';
export const goldenFizz = '#e0fe32';
export const greenApple = '#62cf33';
export const lakeBlue = '#043646';
export const lime = '#c0df16';
export const mountainMeadows = '#28e1a5';
export const redApple = '#fd1a0e';
export const abbey = '#585a5d';
export const shark = '#2e3134';

export const blueGray = '#2e3134';
export const blueGray26 = 'rgba(46, 49, 52, .26)';
export const blueGray30 = 'rgba(46, 49, 52, .3)';
export const blueGray54 = 'rgba(46, 49, 52, .54)';
export const blueGray80 = 'rgba(46, 49, 52, .8)';

export const ifitBlack12 = 'rgba(21, 21, 21, .12)';
export const ifitBlack20 = 'rgba(21, 21, 21, .20)';
export const ifitBlack26 = 'rgba(21, 21, 21, .26)';
export const ifitBlack54 = 'rgba(21, 21, 21, .54)';
export const ifitBlack80 = 'rgba(21, 21, 21, .8)';

export const white = '#fff';
export const white12 = 'rgba(255, 255, 255, .12)';
export const white30 = 'rgba(255, 255, 255, .3)';
export const white54 = 'rgba(255, 255, 255, .54)';
export const white70 = 'rgba(255, 255, 255, .7)';
export const white80 = 'rgba(255, 255, 255, .8)';

export const solidBlack = '#000';
export const solidWhite = '#fff';
